import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import DocumentationPage from './pages/DocumentationPage';
import ExamplesPage from './pages/ExamplesPage';
import ApiReferencePage from './pages/ApiReferencePage';
import GuidesPage from './pages/GuidesPage';
import ComponentsPage from './pages/ComponentsPage';

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/docs" element={<DocumentationPage />} />
        <Route path="/components" element={<ComponentsPage />} />
        <Route path="/examples" element={<ExamplesPage />} />
        <Route path="/api" element={<ApiReferencePage />} />
        <Route path="/guides/:slug?" element={<GuidesPage />} />
      </Routes>
    </Layout>
  );
}

export default App;

